import decode from 'jwt-decode'
import { UserData } from '../reducers'

export function parseToken(token: string): UserData | null {
  try {
    const now = Math.floor(Date.now() / 1000)
    const decoded = decode(token)

    if (decoded.exp < now) {
      console.warn('Expired authentication token')
      // Should we also reopen the WS connection here?
      localStorage.removeItem('peikko-dbs-token')
      return null
    }

    return {
      username: decoded.username,
      fullName: decoded.fullname,
      company: decoded.company,
      country: decoded.country
    }
  } catch (e) {
    console.warn('Invalid token', e)
    return null
  }
}



// WEBPACK FOOTER //
// ./src/util/parseToken.ts